/*
 * @Description: 几何形状
 * @Author: 蔺晨
 * @Date: 2020-12-11
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './index.less';

export default class Shape extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const {
      id,
      type = 'square',
      w = 'auto',
      h = 'auto',
      r = 0,
      margin = 0,
      style = {},
      isFlash = true
    } = this.props;
    if (!['square', 'circular'].includes(type)) {
      throw new Error(`Shape's props of type must is square or circular!`);
      return null;
    }
    return (
      <div
        id={id}
        className={cx('linchen-shape', [type], { flash: isFlash })}
        style={{
          width: w,
          height: h,
          borderRadius: type == 'circular' ? '100%' : r,
          margin,
          ...style
        }}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/FrameWork/Shape/index.js